'use client';
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Мутирует первый объект, перезаписывая в нём вхождения,
 * вхождениями из второго объекта.
 * */ var mergeStyles = function(current, extra) {
    if (extra) {
        for(var key in extra){
            current[key] = current[key] ? _extends({}, current[key], extra[key]) : extra[key];
        }
    }
    return current;
};

export { mergeStyles };
